// ThankYou.jsx
import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import Confetti from "react-confetti";
import QRCode from "react-qr-code";
import nov2026 from "./nov2026_161718.png";

const ThankYou = () => {
  const location = useLocation();
  // Expecting qrUrl passed via state or fallback to query param "u"
  const qrUrl =
    location.state?.qrUrl ||
    new URLSearchParams(location.search).get("u") ||
    "";

    console.log(qrUrl, 'url')

  if (!qrUrl) {
    // If nothing meaningful, optionally redirect back to form or show message
    return <div>Oops, no registration data found. Please go back and submit the form.</div>;
  }

  return (
    <>
      <div style={{ padding: "2rem", maxWidth: 700, margin: "0 auto", textAlign: "center" }}>
        <h2>Thank You for Registering!</h2>
        <div style={{ marginTop: 40 }}>
          <QRCode value={qrUrl} size={128} style={{ margin: "auto" }} />
          <div style={{ paddingTop: 20, textAlign: "center" }}>
            <p>
              <strong style={{ borderBottom: "2px solid red" }}>
                Please present this QR code to the registration desk upon your arrival at the fair, as it will facilitate your seamless entry. Your cooperation in this matter is sincerely appreciated.
              </strong>
            </p>
            <p>
              As a form of guidance, we kindly advise you to capture a screenshot of this QR code and store it in your image gallery for ease of access. This identical QR code is also in your registered email.
            </p>
            <div style={{ marginTop: 10 }}>
              <img src={nov2026} alt="date" height="120px" />
              <br />
              <b>FREE ENTRY</b>
              <br />
              <b>AMPLE PAID PARKING AVAILABLE</b>
              <br />
              <b>EXCLUSIVE BUYERS LOUNGE</b>
            </div>
            <div style={{ marginTop: 10, textAlign: "left" }}>
              <b>Notice for visitors:</b>
              <br />
              <span style={{ color: "red", fontWeight: 700 }}>
                Bags and samples of any size are not allowed inside the fair.
              </span>
              <br />
              <span style={{ color: "red", fontWeight: 700 }}>
                Entry is only allowed for visitors aged 16 and above.
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThankYou;
